export const getInitials = (name = "") =>
  name.split(/\s+/).filter(Boolean).map((s) => s[0]).join("").slice(0, 2).toUpperCase();

export const normKey = (s) => (s || "").trim().toLowerCase();

export const stripYear = (s) => (s || "").replace(/\s+\(\d{4}\)$/, "");

// Looser fallback — strips any trailing parenthetical
export const stripParens = (s) => (s || "").replace(/\s*\([^)]*\)\s*$/, "");

/**
 * Builds the interior sequence (actors + mid movies) from a completed reel's chains.
 * movie_chain is [Start, Mid..., End] so interior movies are those between start & end.
 */
export const buildInteriorSeq = (actor_chain = [], movie_chain = []) => {
  const mids = movie_chain.slice(1, Math.max(0, movie_chain.length - 1));
  const seq = [];
  const maxLen = Math.max(actor_chain.length, mids.length);
  for (let i = 0; i < maxLen; i++) {
    if (actor_chain[i]) seq.push({ type: "actor", name: actor_chain[i] });
    if (mids[i]) seq.push({ type: "movie", name: mids[i] });
  }
  return seq;
};
